import { api } from "./api";
import { formatDateTime } from "./format";

// ===============================================================
// WO Reject/Remake API client — Phase 1C WP-3γ Step 3.
// Nested endpoints under /api/wo/{wo_id}/reject-remake.
// Backend authoritative role gating; UI mirrors matrix.
// ===============================================================

const base = (woId) => `/wo/${woId}/reject-remake`;

export const rrApi = {
  list: (woId, params = {}) => api.get(base(woId), { params }).then(r => r.data),
  get: (woId, id) => api.get(`${base(woId)}/${id}`).then(r => r.data),
  create: (woId, data) => api.post(base(woId), data).then(r => r.data),
  startRemake: (woId, id) => api.post(`${base(woId)}/${id}/start-remake`).then(r => r.data),
  // BUSINESS-21: Kepala Cabang region memutus remake dari QC packing.
  persetujuanKc: (woId, id, setuju, catatan) => api.post(`${base(woId)}/${id}/persetujuan-kc`, { setuju, catatan }).then(r => r.data),
  resolve: (woId, id, resolution_notes) =>
    api.post(`${base(woId)}/${id}/resolve`, { resolution_notes }).then(r => r.data),
  cancel: (woId, id, reason) =>
    api.post(`${base(woId)}/${id}/cancel`, { reason }).then(r => r.data),
  uploadEvidence: (woId, id, file, notes) => {
    const fd = new FormData();
    fd.append("file", file);
    if (notes) fd.append("notes", notes);
    return api.post(`${base(woId)}/${id}/evidence`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then(r => r.data);
  },
  signedUrl: (woId, id, evidenceId) =>
    api.get(`${base(woId)}/${id}/evidence/${evidenceId}/signed-url`).then(r => r.data),
  deleteEvidence: (woId, id, evidenceId) =>
    api.delete(`${base(woId)}/${id}/evidence/${evidenceId}`).then(r => r.data),
};

// Enum labels (Indonesian) for UI display.
export const CAUSE_LABELS = {
  FABRIC_DEFECT: "Cacat Bahan",
  MISALIGNMENT: "Tidak Sejajar / Misalignment",
  STITCHING_ERROR: "Kesalahan Jahitan",
  MEASUREMENT_MISMATCH: "Ukuran Tidak Sesuai",
  PRINT_DEFECT: "Cacat Cetak",
  COLOR_MISMATCH: "Warna Tidak Sesuai",
  OTHER: "Lain-lain",
};

export const CAUSE_ORDER = [
  "FABRIC_DEFECT", "MISALIGNMENT", "STITCHING_ERROR",
  "MEASUREMENT_MISMATCH", "PRINT_DEFECT", "COLOR_MISMATCH", "OTHER",
];

// Batch 2.2: STAGE_ORDER + STAGE_LABEL DIHAPUS dari sini. Daftar tahap
// datang dari master lewat `lib/productionStages.js` (GET
// /api/production-stages) — bukan konstanta yang harus disunting tiap
// kali tahap berubah. Konstanta di bawah (cause/status/type) tetap
// hardcode karena memang enum CHECK di database, bukan data master.

// Q68-01 Batch 7. `STATUS_META` dan `TYPE_META` DIHAPUS dari sini — peta
// `cls:` yang jadi SUMBER KEBENARAN KETIGA untuk warna badge, terpisah dari
// `TONE_TO_CLASS` (sudah dihapus Batch 6) dan `TONE_CLASSES`. Warna DAN label
// keduanya sekarang di `components/etams/StatusBadge.jsx` sebagai
// `RR_STATUS_TONE` / `RR_TYPE_TONE`, dirender lewat `RRStatusBadge` /
// `RRTypeBadge`.
//
// Berkas ini kembali ke tugas aslinya: klien API + kosakata enum, nol warna.
// Konstanta cause/status/type memang hardcode karena enum CHECK di database —
// tapi itu alasan untuk menyimpan KODE-nya, bukan kelas Tailwind-nya.

// #4b-1 (Q64/Q66): delegasi ke formatter resmi lib/format (A6).
export const fmtDate = (iso) => formatDateTime(iso);
